"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Columns = exports.ColumnsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
exports.ColumnsDefaultProps = {
  border: false,
  variant: "1|1"
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: stretch;\n    overflow: hidden;\n    ", "\n  "], ["\n    display: flex;\n    align-items: stretch;\n    overflow: hidden;\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props._height);
  })
});
var StartColumnStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: 50%;\n    box-sizing: border-box;\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n  "], ["\n    width: 50%;\n    box-sizing: border-box;\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n  "])), function (props) {
    return props._border && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border-right: 1px solid ", ";\n    "], ["\n      border-right: 1px solid ", ";\n    "])), theme_1.theme.COLOR('line-mid'));
  }, function (props) {
    return props.variant === '1|1' && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      width: 50%;\n    "], ["\n      width: 50%;\n    "])));
  }, function (props) {
    return props.variant === '1|2' && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: 33.3333%;\n    "], ["\n      width: 33.3333%;\n    "])));
  }, function (props) {
    return props.variant === '2|1' && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      width: 66.6667%;\n    "], ["\n      width: 66.6667%;\n    "])));
  }, function (props) {
    return props.variant === '1|3' && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      width: 25%;\n    "], ["\n      width: 25%;\n    "])));
  }, function (props) {
    return props.variant === '3|1' && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      width: 75%;\n    "], ["\n      width: 75%;\n    "])));
  }, function (props) {
    return props.variant === '2|3' && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      width: 40%;\n    "], ["\n      width: 40%;\n    "])));
  }, function (props) {
    return props.variant === '3|2' && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      width: 60%;\n    "], ["\n      width: 60%;\n    "])));
  })
});
var EndColumnStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    width: 50%;\n    overflow-y: auto;\n    box-sizing: border-box;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    width: 50%;\n    overflow-y: auto;\n    box-sizing: border-box;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), function (props) {
    return props.variant === '1|1' && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      width: 50%;\n    "], ["\n      width: 50%;\n    "])));
  }, function (props) {
    return props.variant === '1|2' && (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      width: 66.6667%;\n    "], ["\n      width: 66.6667%;\n    "])));
  }, function (props) {
    return props.variant === '2|1' && (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      width: 33.3333%;\n    "], ["\n      width: 33.3333%;\n    "])));
  }, function (props) {
    return props.variant === '1|3' && (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      width: 75%;\n    "], ["\n      width: 75%;\n    "])));
  }, function (props) {
    return props.variant === '3|1' && (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      width: 25%;\n    "], ["\n      width: 25%;\n    "])));
  }, function (props) {
    return props.variant === '3|2' && (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      width: 40%;\n    "], ["\n      width: 40%;\n    "])));
  }, function (props) {
    return props.variant === '2|3' && (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      width: 60%;\n    "], ["\n      width: 60%;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  StartColumn: styled_components_1.default.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), StartColumnStyles),
  EndColumn: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), EndColumnStyles)
};
var Columns = function (props) {
  var className = props.className,
    height = props.height,
    start = props.start,
    end = props.end,
    border = props.border,
    variant = props.variant;
  return react_1.default.createElement(My.Container, {
    variant: variant,
    _height: height,
    className: className
  }, react_1.default.createElement(My.StartColumn, {
    variant: variant,
    _border: border
  }, start), react_1.default.createElement(My.EndColumn, {
    variant: variant
  }, end));
};
exports.Columns = Columns;
exports.Columns.defaultProps = exports.ColumnsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;